import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from "@apollo/client";
import React from "react";
import { CREATE_COMMENT_REPLY } from "../../apollo/operations";
import { CommentReplyMenu, CommentReplyContent, CommentReplyInput } from "..";
import { CommentReplyTypes } from "../../types";

type CommentReplyProps = {
  id?: string;
  replyComment: string;
  setReplyComment: (value: React.SetStateAction<string>) => void;
  openInput?: boolean;
  setOpenInput: (value: React.SetStateAction<boolean>) => void;
  getReply: CommentReplyTypes[] | undefined;
  refetch: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<any>>;
  loading: boolean;
  textArea: React.MutableRefObject<HTMLTextAreaElement | null>;
  replyButtonHandler: (user: string) => void;
  setEditingCommentIndex: React.Dispatch<React.SetStateAction<number | null>>;
  editingCommentIndex: number | null;
};
const CommentReply: React.FC<CommentReplyProps> = ({
  id,
  replyComment,
  setReplyComment,
  openInput,
  setOpenInput,
  getReply,
  refetch,
  loading,
  textArea,
  replyButtonHandler,
  setEditingCommentIndex,
  editingCommentIndex,
}) => {
  const [deleteOption, setDeleteOption] = React.useState(false);
  const [openOption, setOpenOption] = React.useState(null);
  const [openEdit, setOpenEdit] = React.useState<number | null>(null);
  const [onChange, setOnChange] = React.useState(false);
  const userID = localStorage.getItem("user");
  // const [openMoreReply, setOpenMoreReply] = React.useState<number | null>(null);

  // console.log(userID);

  const handleCloseInput = () => {
    setOpenInput(false);
  };

  const [createCommentReply, { loading: loadReply, error: errorMessage }] =
    useMutation(CREATE_COMMENT_REPLY, {
      onCompleted: (data) => {
        console.log(data);
        refetch();
      },
      onError(err) {
        console.log(err);
        const _error = err.graphQLErrors[0]?.extensions?.originalError;
        console.log(_error);
      },
    });

  const handleCreateReply = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    createCommentReply({
      variables: {
        data: {
          comment: {
            id: id,
          },
          commentBy: {
            id: userID,
          },
          message: replyComment,
        },
      },
    }).then(() => {
      handleCloseInput();
      setReplyComment("");
    });
  };

  // console.log(getReply, "get Reply");
  const handleToggle = (index: any) => {
    setOpenOption((prev) => (prev === index ? null : index));
  };

  const handleOpenNotice = () => {
    setOpenOption(null);
    setDeleteOption(true);
  };

  const handleEdit = (index: number) => {
    setOpenOption(null); // Close any open option
    setEditingCommentIndex(index);
    if (openEdit === index) {
      setOpenEdit(null); // Close the edit for the clicked item
    } else {
      setOpenEdit(index); // Open the edit for the clicked item
    }
  };

  const handleCloseNotice = () => {
    setDeleteOption(false);
  };
  const index: number = 0;

  // if (loading) {
  //   return (
  //     getReply &&
  //     getReply?.length > 0 && (
  //       <div className="w-[80%] ml-[15%] pl-10 border-solid border-l py-2">
  //         {[1, 2].map((n) => (
  //           <CommentReplyLoading key={n} />
  //         ))}
  //       </div>
  //     )
  //   );
  // }

  return (
    ((getReply && getReply.length > 0) || openInput) && (
      <div className="lg:w-[80%] w-full lg:ml-[15%] lg:pl-10 pl-4 border-solid border-l py-2">
        {errorMessage && <div>{errorMessage.message}</div>}
        {openInput && (
          <div className="w-full">
            <CommentReplyInput
              communityComment={replyComment}
              setCommunityComment={setReplyComment}
              handleSubmit={handleCreateReply}
              textArea={textArea}
              loading={loadReply}
              onChange={onChange}
              setOnChange={setOnChange}
              openEdit={openEdit}
              index={index}
            />
            {/* <button>cancel</button> */}
          </div>
        )}
        {getReply &&
          getReply?.map((reply, index) => (
            <div className="w-full">
              <div
                className="w-full flex flex-col lg:px-5 lg:py-3 px-1 rounded shadow mb-1 gap-2"
                key={index}
              >
                <CommentReplyMenu
                  commentReply={reply}
                  openOption={openOption}
                  handleToggle={handleToggle}
                  deleteOption={deleteOption}
                  index={index}
                  key={index * 2}
                  handleCloseNotice={handleCloseNotice}
                  handleEdit={handleEdit}
                  setOpenOption={setOpenOption}
                  handleOpenNotice={handleOpenNotice}
                  refetch={refetch}
                />
                <CommentReplyContent
                  id={reply.id}
                  content={reply.message}
                  createdAt={reply.createdAt}
                  index={index}
                  refetch={refetch}
                  userID={userID}
                  openEdit={openEdit}
                  onChange={onChange}
                  setOnChange={setOnChange}
                  textArea={textArea}
                  setOpenEdit={setOpenEdit}
                  commentId={id}
                />
              </div>
              {editingCommentIndex === index && loading && (
                <div className="text-midGreen text-[10px] font-Poppins font-normal ml-2">
                  Posting...
                </div>
              )}
            </div>
          ))}
      </div>
    )
  );
};

export default CommentReply;
